<script setup>
import { ref, watchEffect } from 'vue'

import ColorPicker from '@/tiptap/extensions/components/ColorPicker.vue'
import ActionButton from '@/tiptap/extensions/components/ActionButton/src/index.vue'
import { extActionButtonProps } from '@/tiptap/extensions/components/ActionButton/src/props'

const props = defineProps(extActionButtonProps)

const highlight = ref('')

function action(color) {
  const chain = props.editor.chain().focus()
  if (!color) {
    chain.unsetHighlight().run()
  } else {
    chain.setHighlight({ color }).run()
  }
}

watchEffect(() => {
  const { color: highlightValue } = props.editor.getAttributes('highlight')
  highlight.value = highlightValue
})
</script>

<template>
  <ActionButton
    :editor="editor"
    icon="highlight"
    :tooltip="t('editor.highlight.tooltip')"
    :disabled="!editor.can().setHighlight()"
    :color="highlight"
    :is-active="() => editor.isActive('highlight') || false"
  >
    <ColorPicker
      v-model="highlight"
      mode="highlight"
      activator="parent"
      :nudge-top="-4"
      :nudge-left="8"
      @change="action"
    />
  </ActionButton>
</template>
